import React, { useState } from 'react';
import Login from './Login';
import RealisticParentLogin from './RealisticParentLogin';

function LoginSelection({ onLogin }) {
  const [selectedType, setSelectedType] = useState(null);

  if (selectedType === 'student') {
    return <Login onLogin={onLogin} onBack={() => setSelectedType(null)} />;
  }

  if (selectedType === 'parent') {
    return <RealisticParentLogin onLogin={onLogin} onBack={() => setSelectedType(null)} />;
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1E40AF 0%, #F97316 50%, #FCD34D 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'Inter, sans-serif'
    }}>
      <div style={{
        maxWidth: '450px',
        width: '100%',
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 25px 50px rgba(0,0,0,0.2)',
        overflow: 'hidden'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #1E40AF, #F97316)',
          padding: '40px 30px',
          textAlign: 'center',
          color: 'white'
        }}>
          <div style={{
            width: '70px',
            height: '70px',
            background: 'white',
            borderRadius: '18px',
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
          }}>
            <div style={{
              fontSize: '28px',
              color: '#1E40AF',
              fontWeight: 'bold'
            }}>R</div>
          </div>
          <h1 style={{
            fontSize: '26px',
            fontWeight: '700',
            marginBottom: '8px'
          }}>The Rising School</h1>
          <p style={{
            fontSize: '16px',
            opacity: '0.9'
          }}>Management System</p>
        </div>

        <div style={{
          padding: '40px 30px'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#1F2937',
            textAlign: 'center',
            marginBottom: '8px'
          }}>Choose Login Type</h2>
          <p style={{
            fontSize: '14px',
            color: '#6B7280',
            textAlign: 'center',
            marginBottom: '30px'
          }}>Select your role to access the appropriate portal</p>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            marginBottom: '30px'
          }}>
            <button 
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '20px',
                border: '2px solid #E5E7EB',
                borderRadius: '15px',
                background: '#F9FAFB',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textAlign: 'left'
              }}
              onClick={() => setSelectedType('student')}
            >
              <div style={{
                fontSize: '32px',
                marginRight: '15px'
              }}>🎓</div>
              <div style={{ flex: 1 }}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#1F2937',
                  marginBottom: '4px'
                }}>Students & Staff</h3>
                <p style={{
                  fontSize: '14px',
                  color: '#6B7280'
                }}>Access school management system</p>
              </div>
              <div style={{
                fontSize: '20px',
                color: '#9CA3AF',
                fontWeight: 'bold'
              }}>→</div>
            </button>

            <button 
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '20px',
                border: '2px solid #E5E7EB',
                borderRadius: '15px',
                background: '#F9FAFB',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textAlign: 'left'
              }}
              onClick={() => setSelectedType('parent')}
            >
              <div style={{
                fontSize: '32px',
                marginRight: '15px'
              }}>👥</div>
              <div style={{ flex: 1 }}>
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#1F2937',
                  marginBottom: '4px'
                }}>Parents Business</h3>
                <p style={{
                  fontSize: '14px',
                  color: '#6B7280'
                }}>Access parent community & business network</p>
              </div>
              <div style={{
                fontSize: '20px',
                color: '#9CA3AF',
                fontWeight: 'bold'
              }}>→</div>
            </button>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '15px'
          }}>
            <div style={{
              background: '#F8FAFC',
              padding: '15px',
              borderRadius: '12px',
              border: '1px solid #E5E7EB'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1F2937',
                marginBottom: '8px'
              }}>🎯 For Students & Staff</h4>
              <p style={{
                fontSize: '12px',
                color: '#6B7280',
                lineHeight: '1.4'
              }}>Access attendance, grades, assignments, and school resources</p>
            </div>
            <div style={{
              background: '#F8FAFC',
              padding: '15px',
              borderRadius: '12px',
              border: '1px solid #E5E7EB'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1F2937',
                marginBottom: '8px'
              }}>🏪 For Parents</h4>
              <p style={{
                fontSize: '12px',
                color: '#6B7280',
                lineHeight: '1.4'
              }}>Connect with parent community, promote business, find jobs</p>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}

export default LoginSelection;